import { I18N_FALLBACK_LOCALE } from '@withjoy/locale';

// Only used to parse relative URLs; it never appears in the result.
const RELATIVE_URL_BASE = 'https://withjoy.com';
const ABSOLUTE_URL = /^[a-z][a-z\d+.-]*:\/\//i;

/**
 * A page's URL in a locale: the bare URL for the default locale, `?l=<locale>` otherwise, which is
 * the param the i18n language detector reads. Same rule as marcom's `localeUrl`, so the two sites'
 * hreflang links agree.
 */
export const localeUrl = (url: string, locale: string): string => {
  const isAbsolute = ABSOLUTE_URL.test(url);
  const parsedUrl = new URL(url, RELATIVE_URL_BASE);
  if (locale === I18N_FALLBACK_LOCALE) {
    parsedUrl.searchParams.delete('l');
  } else {
    parsedUrl.searchParams.set('l', locale);
  }
  return isAbsolute ? parsedUrl.toString() : `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
};
